export type FullscreenElement = Element & {
  requestFullscreen?: () => Promise<void>
  mozRequestFullScreen?: () => Promise<void>
  webkitRequestFullscreen?: () => Promise<void>
  msRequestFullscreen?: () => Promise<void>
}

export type DocumentWithFullscreen = Document & {
  exitFullscreen?: () => Promise<void>
  mozCancelFullScreen?: () => Promise<void>
  webkitExitFullscreen?: () => Promise<void>
  msExitFullscreen?: () => Promise<void>
}

export function requestFullscreen(el?: FullscreenElement | null): Promise<void> {
  if (typeof document === 'undefined') return Promise.resolve()
  const element = (el || document.documentElement) as FullscreenElement
  if (!element) return Promise.resolve()

  if (element.requestFullscreen) {
    return element.requestFullscreen()
  } else if (element.mozRequestFullScreen) {
    // Firefox
    return element.mozRequestFullScreen()
  } else if (element.webkitRequestFullscreen) {
    // Chrome, Safari, and Opera
    return element.webkitRequestFullscreen()
  } else if (element.msRequestFullscreen) {
    // IE/Edge
    return element.msRequestFullscreen()
  }

  return Promise.resolve()
}

export async function exitFullscreen(): Promise<void> {
  const doc = document as DocumentWithFullscreen

  if (doc.exitFullscreen) {
    return doc.exitFullscreen()
  } else if (doc.mozCancelFullScreen) {
    // Firefox
    return doc.mozCancelFullScreen()
  } else if (doc.webkitExitFullscreen) {
    // Chrome, Safari, and Opera
    return doc.webkitExitFullscreen()
  } else if (doc.msExitFullscreen) {
    // IE/Edge
    return doc.msExitFullscreen()
  }

  return Promise.resolve()
}

export function toggleFullscreen(element: FullscreenElement): void {
  if (!document.fullscreenElement) {
    requestFullscreen(element)
  } else {
    exitFullscreen()
  }
}

export function isFullscreen(): boolean {
  return !!document.fullscreenElement
}
